export default {"src":"/_next/static/media/voxies-logo.a6ca410d.svg","height":141,"width":392,"blurWidth":0,"blurHeight":0};